import { forwardRef } from "react";

export const LoopVideo = forwardRef(function LoopVideo(
  { src, poster, className = "", testId, muted = true },
  ref
) {
  return (
    <video
      ref={ref}
      src={src}
      poster={poster}
      autoPlay
      muted={muted}
      loop
      playsInline
      preload="metadata"
      aria-hidden="true"
      data-testid={testId}
      className={`h-full w-full object-cover ${className}`}
    />
  );
});
